const dashboardTab = [
    {id: "sales", text: "Sales"},
    // {id: "staff", text: "Staff"},
];

const memberTabLists = [
    { id: "active", text: "Active Member"},
    { id: "hidden", text: "Hidden Member"},
    { id: "changeMobile", text: "Change Mobile"},
    // { id: "merge", text: "Merged Member"},
    { id: "delete", text: "Deleted Member"},
];

const membershipTabs = [
    { id: "", text: "All"},
    { id: "memberVip", text: "VIP"},
    { id: "memberVvip", text: "VVIP"},
    { id: "memberVvvip", text: "VVVIP"}
];

const brandConfigTabs = [
    {id: "membershipTag", text: "Membership Tag"},
    {id: "memberInfo", text: "Member Info"},
];

const setupTabs = [
    { id: 1, text: "General Info"},
    { id: 2, text: "Staff"},
    { id: 3, text: "Services"},
    { id: 4, text: "Images"},
    { id: 5, text: "Gallery"},
];

const infoTabs = [
    { id: "general", text: "General"},
    { id: "slide", text: "Slide"},
    { id: "gallery", text: "Gallery"},
    { id: "testimonial", text: "Testimonial"}
];

const receiptTabs = [
    { id: "receipt", text: "Receipt"},
    { id: "footer", text: "Footer"},
    { id: "taxation", text: "Taxation"},
    { id: "template", text: "Template"},
];

const securityTabs = [
    { id: "authorize", text: "Authorization"},
    { id: "permission", text: "Permission"}
];

const stockTabs = [
    { id: "stockBalance", text: "Stock Balance"},
    { id: "stockList", text: "All"},
    { id: "stockIn", text: "Stock In"},
    { id: "stockOut", text: "Stock Out"},
];

const configTabLists = [
    { id: "service", text: "Service"},
    { id: "product", text: "Product"},
    { id: "package", text: "Package"},
    { id: "discount", text: "Discount"}
]

const discountTabLists = [
    { id: "discountList", text: "Discounts" },
    { id: "discountSubCategoryList", text: "Discount Sub Category" },
]

const productTabLists = [
    { id: "productList", text: "Products" },
    { id: "productSubCategoryList", text: "Product Sub-Category" }
]

const serviceTabLists = [
    { id: "serviceList", text: "Services" },
    { id: "serviceSubCategoryList", text: "Service Sub-Category" }
]

const reportCommissionTabs = [
    { id: "category", text: "Category" },
    { id: "type", text: "Type" },
    { id: "item", text: "Item" },
    { id: "staff", text: "Staff By Date" }
]

const reportSalesTabs = [
    { id: "date", text: "By Date" },
    { id: "item", text: "By Item" }
]

const reportPaymentTabs = [
    { id: "date", text: "By Date" },
    { id: "order", text: "By Order" }
]

const salesReportTypeTab = [
    {id: "", text: "Sales"},
    {id: "credits", text: "Credit Redeem"},
    {id: "package", text: "Package Redeem"},
    {id: "all", text: "All"},
]

const rewardStatusTabs = [
    {id: "active", text: "Active"},
    {id: "inactive", text: "Inactive"},
    {id: "all", text: "All"},
]

const rewardFormProgressTabs = [
    {id: 1, text: "Promo Information"},
    {id: 2, text: "Promo Value"},
]

const broadcastTabs = [
    {id: "all", text: "All"},
    {id: "1", text: "All Customers"},
    {id: "0", text: "Other Groups"},
]

const reportCreditTabs = [
    {id: "summary", text: "Summary"},
    {id: "list", text: "List"},
]

const reportCreditListAmountType = [
    {id: "all", text: "All"},
    {id: "topup", text: "Top Up"},
    {id: "redeem", text: "Redeem"},
]

const reportCreditSummaryType = [
    {id: "customer", text: "By Customer"},
    {id: "date", text: "By Date"},
]

const reportOutstandingsListAmountType = [
    {id: "all", text: "All"},
    {id: "topup", text: "Outstandings"},
    {id: "redeem", text: "Collection"},
]

const reportVoucherSummaryType = [
    {id: "customer", text: "By Customer"},
    {id: "voucher", text: "By Voucher"},
    {id: "expiry", text: "By Expiry"},
    {id: "date", text: "By Date"},
]

const reportVoucherListType = [
    {id: "signup", text: "Sign Up"},
    {id: "redeem", text: "Redeem"},
    {id: "expired", text: "Expired"},
    {id: "expiry", text: "Expiry"},
    {id: "all", text: "All"},
]

const reportAttendanceType = [
    {id: "all", text: "All"},
    {id: "present", text: "Present"},
    {id: "exit", text: "Exit"},
]

const itemFormTabs = [
    {id: "details", text: "Details"},
    {id: "policy", text: "Policy"},
]

const tukangTabs = [
    {id: "shop", text: "Shop"},
    {id: "staff", text: "Staff"},
]

export default{
    dashboardTab: dashboardTab,
    memberTabLists: memberTabLists,
    membershipTabs: membershipTabs,
    brandConfigTabs: brandConfigTabs,
    setupTabs: setupTabs,
    infoTabs: infoTabs,
    receiptTabs: receiptTabs,
    securityTabs: securityTabs,
    stockTabs: stockTabs,
    configTabLists: configTabLists,
    discountTabLists: discountTabLists,
    productTabLists: productTabLists,
    serviceTabLists: serviceTabLists,
    reportCommissionTabs: reportCommissionTabs,
    reportSalesTabs: reportSalesTabs,
    salesReportTypeTab: salesReportTypeTab,
    rewardStatusTabs: rewardStatusTabs,
    rewardFormProgressTabs: rewardFormProgressTabs,
    broadcastTabs: broadcastTabs,
    reportCreditTabs: reportCreditTabs, 
    reportCreditListAmountType: reportCreditListAmountType, 
    reportCreditSummaryType: reportCreditSummaryType, 
    reportOutstandingsListAmountType: reportOutstandingsListAmountType,
    reportVoucherSummaryType: reportVoucherSummaryType,
    reportVoucherListType: reportVoucherListType,
    reportAttendanceType: reportAttendanceType,
    itemFormTabs: itemFormTabs,
    tukangTabs: tukangTabs,
    reportPaymentTabs: reportPaymentTabs
}
